import {
    Box,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { ReportControlPointData, ReportCreate } from "../../../../types/api/report";
import { MainContext, MainContextState } from "../../../../context/MainContext";
import { useContext } from "react";

interface IProps {
    reportDates: Array<ReportControlPointData>;
    editForm?: boolean;
}
export const ReportCreateForm = ({ reportDates, editForm = false }: IProps) => {
    const { constants } = useContext<Partial<MainContextState>>(MainContext);
    const { control } = useFormContext<ReportCreate>();
    return (
        <Box
            component="form"
            sx={{
                "& .MuiTextField-root": { my: 1 },
            }}
            noValidate
            autoComplete="off">
            {!editForm && (
                <Controller
                    defaultValue={null}
                    name={`report_date_id`}
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange, value }, fieldState }) => (
                        <FormControl sx={{ width: "100%", my: 1 }}>
                            <InputLabel id={"report-date-id-label"}>Контрольная точка</InputLabel>
                            <Select
                                size={"small"}
                                fullWidth
                                labelId={"report-date-id-label"}
                                label={"Контрольная точка"}
                                onChange={(event: SelectChangeEvent) => {
                                    onChange(event.target.value as string);
                                }}
                                value={String(value)}
                                defaultValue={" "}
                                autoComplete="off"
                                error={!!fieldState?.error}>
                                {reportDates?.map(reportDate =>
                                    reportDate.report_type !== 8 ? (
                                        <MenuItem key={reportDate.id} value={reportDate.id}>
                                            <Stack direction={"column"}>
                                                <Typography variant="body1">{reportDate.name}</Typography>
                                                <Typography variant="caption">{reportDate.description}</Typography>
                                                <Typography variant="caption">
                                                    {
                                                        constants?.export_type.find(
                                                            state => state.value === Number(reportDate.report_type),
                                                        )?.text
                                                    }
                                                </Typography>
                                            </Stack>
                                        </MenuItem>
                                    ) : null,
                                )}
                            </Select>
                            <FormHelperText>{fieldState?.error?.message}</FormHelperText>
                        </FormControl>
                    )}
                />
            )}
            {/* <Controller
                defaultValue={0}
                name={"status.state"}
                control={control}
                render={({ field: { onChange, value }, fieldState }) => (
                    <FormControl sx={{ width: "100%", my: 1 }}>
                        <InputLabel id={"contract-type-label"}>Статус</InputLabel>
                        <Select
                            size={"small"}
                            fullWidth
                            labelId={"contract-type-label"}
                            label={"Статус"}
                            onChange={(event: SelectChangeEvent) => {
                                onChange(event.target.value as string);
                            }}
                            value={String(value)}
                            defaultValue={"0"}
                            autoComplete="off"
                            error={!!fieldState?.error}>
                            {constants?.report_state?.map((type: any) => (
                                <MenuItem key={type.value} value={type.value}>
                                    {type.text}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>{fieldState?.error?.message}</FormHelperText>
                    </FormControl>
                )}
            /> */}
            <Controller
                defaultValue={""}
                name={"status.message"}
                control={control}
                render={({ field, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                        label={"Комментарий"}
                        error={!!fieldState?.error}
                        helperText={fieldState?.error?.message}
                    />
                )}
            />
        </Box>
    );
};
